import { SidebarGroup, SidebarMenu } from "ui/components/sidebar";
import { MasterData } from "./master-data";
import { Casestudies } from "./casestudies";
import { Explore } from "./explore";

export function NavMain() {
  return (
    <SidebarGroup>
      <SidebarMenu>
        <Casestudies />
        <MasterData />
        <Explore />
      </SidebarMenu>
    </SidebarGroup>
  );
}
